module.exports = __webpack_public_path__ + "img/txmn-1-sm.14e92470.jpg";